import React from 'react';
import Layout from '../../components/ui/Layout';
// import { useAuth } from '../../components/context/AuthContext'; // No longer needed here
// import { Link } from 'react-router-dom'; // No longer needed here
import InventoryPage from '../private/inventory/InventoryPage';

export default function InventoryPublicPageWrapper() { // Renamed for clarity
  // const { userRole } = useAuth(); // Logic moved to InventoryPage.js

  return (
    <Layout>
      {/* "Add Inventory" link is now inside InventoryPage.js and conditional there */}
      <InventoryPage />
    </Layout>
  );
}
